import styled from 'styled-components';

export default styled.p`
	display: table;
	width: 100%;
	margin: 0 auto 1.6rem;
	font-family: ${props => props.theme.f1};
`;
